import i18n from 'i18next'
import LanguageDetector from "i18next-browser-languagedetector"
import {initReactI18next} from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import Backend from 'i18next-http-backend';
import languageEN from './en/translate.json'
import languageID from './id/translate.json'

i18n
    .use(XHR)
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            id: languageID,
            en: languageEN
        },
        react: {
            useSuspense: false,
            wait: false,
        },
        /* When react i18next not finding any language to as default in borwser */
        fallbackLng: "id",
        /* debugger For Development environment */
        debug: true,
        ns: ["translations"],
        defaultNS: "translations",
        keySeparator: ".",
        interpolation: {
            escapeValue: false,
            formatSeparator: ","
        }
    })

export default i18n;
